/*
  Sticky buy bar for the product page, modelled on Missoma's.

  It deliberately owns no cart logic: the button forwards clicks to the real
  Add to Cart, so variant selection, sold-out states, the cart drawer and any
  app that hooks the form all behave exactly as they do inline. The bar only
  decides when to show itself and mirrors the live price.
*/
(function () {
  if (customElements.get('bb-sticky-atc')) return;

  // Roughly past the first screen of gallery, so it does not cover the product
  // photo the moment the page opens.
  const SHOW_AFTER = 300;

  customElements.define(
    'bb-sticky-atc',
    class BBStickyAtc extends HTMLElement {
      connectedCallback() {
        this.realButton = document.querySelector('product-form [name="add"]');
        this.priceSource = document.querySelector('.product__price');
        this.button = this.querySelector('.bb-sticky-atc__btn');
        this.priceOut = this.querySelector('[data-sticky-price]');

        // Without a real button there is nothing to forward to, so stay away.
        if (!this.realButton || !this.button) return;

        this.button.addEventListener('click', () => this.realButton.click());

        this.syncPrice();
        if (this.priceSource) {
          // The theme rewrites the price node on variant change.
          this.priceWatcher = new MutationObserver(() => this.syncPrice());
          this.priceWatcher.observe(this.priceSource, {subtree: true, childList: true, characterData: true});
        }

        // A scroll listener rather than an IntersectionObserver: going from
        // "below the fold" to "scrolled past" never changes isIntersecting, so
        // a long jump (anchor link, restored scroll position) would leave the
        // bar stuck hidden.
        // Missoma show theirs as soon as you start scrolling, not only once the
        // real button has gone by, so the bar is there whenever someone is
        // actually reading the page.
        this.update = () => {
          this.classList.toggle('is-visible', window.scrollY > SHOW_AFTER);
        };
        this.onScroll = () => {
          if (this.queued) return;
          this.queued = true;
          requestAnimationFrame(() => {
            this.queued = false;
            this.update();
          });
        };

        window.addEventListener('scroll', this.onScroll, {passive: true});
        window.addEventListener('resize', this.onScroll);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.priceWatcher) this.priceWatcher.disconnect();
      }

      syncPrice() {
        if (!this.priceOut || !this.priceSource) return;
        // The price block also carries the compare-at price and a savings
        // badge; the first token is the amount the customer actually pays.
        const text = (this.priceSource.innerText || '').trim();
        const current = text.split(/\s+/)[0] || '';
        if (current !== this.priceOut.textContent) this.priceOut.textContent = current;
      }
    }
  );
})();
